import type {ReactNode} from "react";

import {cn} from "@/lib/utils";

type HelpTargetProps = {
  target: string;
  children: ReactNode;
  className?: string;
};

/** Stable tour anchor — use on real controls, not decorative wrappers. */
export function HelpTarget({target, children, className}: HelpTargetProps) {
  return (
    <div className={className} data-help-target={target}>
      {children}
    </div>
  );
}
